"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

import { Chat } from "@/features/chat/full-view";
import type { ComposerMode } from "@/features/chat/full-view/modes";
import { clearPersistedBuildSession } from "@/features/chat/multi/persistence/clear-persisted-session";
import { setFocusedSession } from "@/features/chat/multi/signals/chat-signals";

export function HomePage() {
  const router = useRouter();

  useEffect(() => {
    setFocusedSession(null);
    clearPersistedBuildSession();
  }, []);

  function startDraft(prompt: string, mode: ComposerMode) {
    setFocusedSession(null);
    clearPersistedBuildSession();
    if (mode.id === "insight") {
      const params = new URLSearchParams({
        prompt,
        fresh: "1",
      });
      router.push(`/insights?${params.toString()}`);
      return;
    }
    const params = new URLSearchParams({
      prompt,
      mode: mode.id,
      fresh: "1",
    });
    router.push(`/flow-builder?${params.toString()}`);
  }

  return <Chat onSubmit={startDraft} />;
}
